// extracted by mini-css-extract-plugin
export default {"pagination":"styles__pagination--hsmUB","pagination-container":"styles__pagination-container--0XuOG"};